__turbopack_context__.v({
  "icon": "Sidebar-module__CazQ7G__icon",
  "wrapper": "Sidebar-module__CazQ7G__wrapper",
});
